import { css } from '@emotion/css'
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { SingleSelectComboboxObject } from '../../../../../legacy-design-system/combobox'
import { Resolution } from '../../api/shared'

import { IntegrationRowProps } from './integration-row'

export const JiraResolutionField: FC<IntegrationRowProps> = ({
  update,
  integrationValue,
  resolutions
}) => {
  const { formatMessage } = useIntl()
  return (
    <div
      className={css`
        display: flex;
        flex-grow: 1;
        div {
          display: flex;
          flex-grow: 1;
        }
      `}
    >
      <SingleSelectComboboxObject<Resolution>
        disabled={
          !integrationValue.issue_status ||
          typeof integrationValue.issue_status === 'string' ||
          integrationValue.issue_status.statusCategory.key !== 'done'
        }
        value={
          integrationValue.issue_resolution &&
          typeof integrationValue.issue_resolution !== 'string'
            ? integrationValue.issue_resolution
            : undefined
        }
        onChange={(value) =>
          update({ ...integrationValue, issue_resolution: value })
        }
        items={[
          {
            items: resolutions ?? []
          }
        ]}
        aria-label={formatMessage({
          id: 'title_integrationsSettings_jiraResolution'
        })}
        itemToString={(item) => item.name}
      />
    </div>
  )
}
